import React from "react";
import STCForm from "./STCForm/STCForm";
import STCCard from "./STCCard/STCCard";
import STCButton from "./STCButton/STCButton";
import STCCol from "./STCCol/STCCol";
import STCContainer from "./STCContainer/STCContainer";
import STCRow from "./STCRow/STCRow";
import STCTable from "./STCTable/STCTable";
import STCInputGroup from "./STCInputGroup/STCInputGroup";
import STCPagination from "./STCPagination/STCPagination";
import STCLogo from "./STCLogo/STCLogo";
import STCIcons from "./STCIcons/STCIcons";
import STCModal from "./STCModal/STCModal";
import STCAlert from "./STCAlert/STCAlert";
import STCFormFloatingLabel from "./STCForm/STCForm.FloatingLabel/STCForm.FloatingLabel";
import { MyAccountClr, PassengersClr, PaymentHistoryClr, STCblue, STCbluedark, STCbluestrong, STCgreen, STCgreendark, STCgreenstrong } from "../../Constants/Constants";
import STCLink from "./STCLink/STC.Link";


function STC() {

    return (
        <></>
    )
}

STC.Alert = STCAlert;
STC.Button = STCButton;
STC.Card = STCCard;
STC.Col = STCCol;
STC.Container = STCContainer;
STC.Form = STCForm;
STC.InputGroup = STCInputGroup;
STC.Link = STCLink;
STC.Pagination = STCPagination;
STC.Row = STCRow;
STC.Table = STCTable;

STC.Logo = STCLogo;

STC.Icons = STCIcons;
STC.Modal = STCModal;

STC.FormFloationglabel = STCFormFloatingLabel;

STC.Blue = STCblue;
STC.BlueStrong = STCbluestrong;
STC.BlueDark = STCbluedark;
STC.Green = STCgreen;
STC.GreenStrong = STCgreenstrong;
STC.GreenDark = STCgreendark;
STC.PassengersClr = PassengersClr;
STC.MyAccountClr = MyAccountClr;
STC.PaymentHistoryClr = PaymentHistoryClr;




export default STC;